module.exports = __webpack_public_path__ + "img/PL00251.416252fb.png";